import React, { useContext, useMemo } from "react";
import { Card, Empty, Spin } from "antd";
import { PageHeader } from "@ant-design/pro-layout";
import {
  DeploymentUnitOutlined,
  EyeOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import CustomBreadcrumb from "../../../components/CustomBreadcrumb";
import { AppContext } from "../../../context/AppContextProvider";

import AddonPreviewModal from "./AddonPreviewModal";
import useAddonReload from "./useAddonReload";
import useAddons from "./useAddons";

const AddonDetail = () => {
  const { appConfig } = useContext(AppContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { addonId } = useParams();

  const isRtl = appConfig?.direction === "rtl";

  const {
    reloadData,
    actionLoading,
    setActionLoading,
    pendingActionReloadRef,
    handleReload,
  } = useAddonReload();

  const { loading, addonData: allAddons } = useAddons({
    reloadData,
    pendingActionReloadRef,
    setActionLoading,
  });

  const addonData = useMemo(
    () => allAddons.find((addon) => addon?.id === Number(addonId)) || null,
    [allAddons, addonId],
  );

  const breadcrumbRoutes = [
    { path: "/", breadcrumbName: t("home"), icon: <HomeOutlined /> },
    {
      path: "/addons",
      breadcrumbName: t("addons"),
      icon: <DeploymentUnitOutlined />,
    },
    {
      path: `/addons/${addonId}`,
      breadcrumbName: t("addon_detail"),
      icon: <EyeOutlined />,
    },
  ];

  return (
    <div className="addons-showcase-page" dir={isRtl ? "rtl" : "ltr"}>
      <Card className="app-mb-20">
        <CustomBreadcrumb menus={breadcrumbRoutes} />
        <PageHeader
          className="app-p-0"
          onBack={() => navigate("/addons")}
          title={t("addon_detail")}
          ghost={false}
        />
      </Card>

      <div className="addon-detail-route">
        <Spin spinning={loading || actionLoading}>
          {!loading && !addonData && (
            <Empty
              className="addon-detail-route__fallback"
              description={t("addon_detail")}
            />
          )}

          <AddonPreviewModal
            addon={addonData}
            open={Boolean(addonData)}
            onClose={() => navigate("/addons")}
            reloadCallback={handleReload}
            actionLoading={actionLoading}
            onActionLoadingChange={setActionLoading}
          />
        </Spin>
      </div>
    </div>
  );
};

export default AddonDetail;
